import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import queryString from 'query-string';

class ErrorSystem extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="modal-header border-0">
                    <h5 className="modal-title" style={{ 'opacity': '0' }}>Confirmation</h5>
                    <button type="button" className="close" onClick={() => this.props.showModal(false)}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <strong>Une erreur s'est produite lors du traitement de cette demande. veuillez réessayer plus tard</strong>
                </div>
                <div className="modal-footer border-0">
                    <button type="button" className="btn btn-outline-light" id="btnLivrerColi" onClick={() => this.ReloadPage()}>Réessayer</button>
                </div>
            </React.Fragment>
        );

    };

    ReloadPage = () => {
        if (window.isNativeApp) {
            return window.ReactNativeWebView.postMessage('page-refresh');
        } else {
            window.location.reload();
        }
    }

}

export default withRouter(ErrorSystem)